import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiService } from 'core/api/services/api.interface';
import { UserApiService } from 'features/user/api/api-tokens';
import { Transaction } from '../../transactions/transaction.model';
import { QuickPayLookupResult, QuickPayRequest } from '../quick-pay.model';

/** The Quick Pay screen's two calls. The allocation side lives on InvoiceDashboardService. */
@Injectable({ providedIn: 'root' })
export class QuickPayService {
  constructor(@Inject(UserApiService) private apiService: IApiService) {}

  lookup(customerNumber: string, invoiceNumber: string): Observable<QuickPayLookupResult> {
    // A blank number is left out rather than sent empty: the API's OpenAPI validator refuses
    // `?customerNumber=` before the request reaches the route.
    let params = new HttpParams();
    if (customerNumber.trim()) params = params.set('customerNumber', customerNumber.trim());
    if (invoiceNumber.trim()) params = params.set('invoiceNumber', invoiceNumber.trim());
    return this.apiService.get<QuickPayLookupResult>('quickPayLookup', { params });
  }

  /** Answers as `/transaction/sale` does: the transaction on success, an error otherwise. */
  charge(body: QuickPayRequest): Observable<Transaction> {
    return this.apiService.post<Transaction>('quickPaySale', { body });
  }
}
